import { call, put } from "redux-saga/effects";
import { IAction } from "front-end-lib/core";
import { StudyService } from "../services";
import { ISaveAssignmentRulePayload } from "../model";
import { openSuccessSnackBar } from "../store";
import { history, initSaga, store } from "../utils";

export enum eAssignmentRuleSaga {
  FETCH_ASSIGNMENT_RULES = "@@assignmentRule/FETCH_ASSIGNMENT_RULES",
  FETCH_ASSIGNMENT_RULES_SUCCESS = "@@assignmentRule/FETCH_ASSIGNMENT_RULES_SUCCESS",
  WATCH_ASSIGNMENT_RULES = "@@assignmentRule/WATCH_ASSIGNMENT_RULES",

  FETCH_ASSIGNMENT_RULE = "@@assignmentRule/FETCH_ASSIGNMENT_RULE",
  FETCH_ASSIGNMENT_RULE_SUCCESS = "@@assignmentRule/FETCH_ASSIGNMENT_RULE_SUCCESS",
  WATCH_ASSIGNMENT_RULE = "@@assignmentRule/WATCH_ASSIGNMENT_RULE",

  SAVE_ASSIGNMENT_RULE = "@@assignmentRule/SAVE_ASSIGNMENT_RULE",
  SAVE_ASSIGNMENT_RULE_SUCCESS = "@@assignmentRule/SAVE_ASSIGNMENT_RULE_SUCCESS",
  WATCH_SAVE_ASSIGNMENT_RULE = "@@assignmentRule/WATCH_SAVE_ASSIGNMENT_RULE"
}

export const fetchAssignmentRulesSaga = function*(action: IAction) {
  const assignmentRules = yield call(
    StudyService.getAssignmentRules,
    action.payload
  );
  yield put({
    type: eAssignmentRuleSaga.FETCH_ASSIGNMENT_RULES_SUCCESS,
    payload: assignmentRules
  });
};

initSaga(
  fetchAssignmentRulesSaga,
  eAssignmentRuleSaga.FETCH_ASSIGNMENT_RULES,
  eAssignmentRuleSaga.WATCH_ASSIGNMENT_RULES
);

export const fetchAssignmentRuleSaga = function*(action: IAction) {
  const assignmentRule = action.payload
    ? yield call(
        StudyService.getAssignmentRule,
        action.payload.studyId,
        action.payload.ruleId
      )
    : undefined;
  yield put({
    type: eAssignmentRuleSaga.FETCH_ASSIGNMENT_RULE_SUCCESS,
    payload: assignmentRule
  });
};

initSaga(
  fetchAssignmentRuleSaga,
  eAssignmentRuleSaga.FETCH_ASSIGNMENT_RULE,
  eAssignmentRuleSaga.WATCH_ASSIGNMENT_RULE
);

export const saveAssignmentRuleSaga = function*(action: IAction) {
  const payload: ISaveAssignmentRulePayload = action.payload;
  const savedRule = yield call(StudyService.saveAssignmentRule, payload);
  yield put({
    type: eAssignmentRuleSaga.SAVE_ASSIGNMENT_RULE_SUCCESS,
    payload: savedRule
  });
  yield history.push(`/study/${payload.studyId}/assignmentrules`);
  yield store.dispatch(openSuccessSnackBar("Save successful"));
};

initSaga(
  saveAssignmentRuleSaga,
  eAssignmentRuleSaga.SAVE_ASSIGNMENT_RULE,
  eAssignmentRuleSaga.WATCH_SAVE_ASSIGNMENT_RULE
);
